import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { detectDevice, setIsMobile } from './device.actions';

@Injectable()
export class DeviceEffects {
  constructor(private actions$: Actions) {}

  detectDevice$ = createEffect(() =>
    this.actions$.pipe(
      ofType(detectDevice),
      map(() => {
        const isMobile =
          /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent,
          );
        return setIsMobile({ isMobile });
      }),
    ),
  );
}
